module.exports = __webpack_public_path__ + "img/detBannerRed.a0d8ccc0.jpg";